const MODULE = "Daily Planner";

const ACTIONS = {
    CONTENT_DUPLICATED: "Daily Planner Content Duplicated",
    EXTRA_NIGHT_ADDED: "Daily Planner Extra Night Added",
    EXTRA_NIGHT_REMOVED: "Daily Planner Extra Night Removed",
    ACTIVITY_SCHEDULED: "Daily Planner Activity Scheduled",
    ACTIVITY_REMOVED: "Daily Planner Activity Removed",
    STATUS_UPDATED: "Daily Planner Status Updated",
    CREATED: "Daily Planner Created",
    UPDATED: "Daily Planner Updated"
};

const ACTION_TYPES = {
  DUPLICATION: "daily_planner_duplication",
  EXTRA_NIGHT_ADD: "daily_planner_extra_night_add",
  EXTRA_NIGHT_REMOVE: "daily_planner_extra_night_remove",
  ACTIVITY_ADD: "daily_planner_activity_add",
  ACTIVITY_REMOVE: "daily_planner_activity_remove",
  STATUS_DRAFT: "daily_planner_status_draft",
  STATUS_ACTIVE: "daily_planner_status_active",
  CREATE: "daily_planner_create",
  UPDATE: "daily_planner_update"
};

export const DAILY_PLANNER_LOG_TYPES = {
  MODULE,
  ACTIONS,
  ACTION_TYPES
};

export const createPlannerTitle = (sailingDate, duration) => {
  const moment = require('moment');
  const startDate = moment(sailingDate).format("DD MMM");
  const endDate = moment(sailingDate).add(duration, 'days').format("DD MMM YYYY");
  return `${startDate} to ${endDate} | ${duration} Nights`;
};